import Section from "@/components/Section";
import InfoCard from "@/components/UI-Kit/InfoCard";
import { productHelpData } from "@/utils/staticData/dataConstants";
import { Grid, Typography } from "@mui/material";

const ProductSection = () => {
  return (
    <Section pt={{ xs: 0, md: 10 }} pb={{ xs: 7.5, md: 8.75 }}>
      <Typography
        variant="h2"
        sx={{
          marginBottom: { xs: "24px", md: "32px" },
        }}
      >
        Product Information
      </Typography>
      <Grid container spacing={2}>
        {productHelpData.map((data, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <InfoCard
              title={data.title}
              description={data.description}
              iconUrl={data.iconUrl}
              path={data.path || "#"}
              withArrow={data.withArrow}
            />
          </Grid>
        ))}
      </Grid>
    </Section>
  );
};

export default ProductSection;
